import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import style from './tabs.module.css';
import { tabsChildValidator } from './tabs-child-validator';
import { DeprecatedTabButton } from './tab-button';
import { DeprecatedTabContent } from './tab-content';

const tabButtonType = (<DeprecatedTabButton />).type;
const tabContentType = (<DeprecatedTabContent />).type;

export const DeprecatedTabs = ({ children, className = '', headerClassName = '', bodyClassName = '' }) => {
  const filteredChildren = React.Children.toArray(children).filter((child) => !!child);
  return (
    <div className={classnames(style.tabs, className)}>
      <div className={classnames(style['tabs-header'], headerClassName)}>
        {filteredChildren.map((tab, index) => {
          const tabButton = tab.props.children.find((child) => child.type === tabButtonType);
          return React.cloneElement(tabButton, {
            selected: tab.props.selected,
            key: index,
          });
        })}
      </div>
      <div className={classnames(style['tabs-body'], bodyClassName)}>
        {filteredChildren.map((tab, index) => {
          if (!tab.props.selected) {
            return null;
          }
          const tabContent = tab.props.children.find((child) => child.type === tabContentType);
          return React.cloneElement(tabContent, { key: index });
        })}
      </div>
    </div>
  );
};

DeprecatedTabs.propTypes = {
  children: PropTypes.oneOfType([tabsChildValidator]).isRequired,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
};
